import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_797 implements Validator {

    public static id = 'CTRL_797';
    private message = 'error.ctr_797';


    public LOG: LogService = new LogService(CTRL_797);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_797.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const travauxNameWithStepId = map.get(ctrl.value.rgCtrls.travaux);
                const calendrierUlterieursMoisNameWithStepId = map.get(ctrl.value.rgCtrls.mois);
                const calendrierUlterieursJoursNameWithStepId = map.get(ctrl.value.rgCtrls.jours);
                const travauxCtrl = form.controls[travauxNameWithStepId];
                const calendrierUlterieursMoisCtrl = form.controls[calendrierUlterieursMoisNameWithStepId];
                const calendrierUlterieursJoursCtrl = form.controls[calendrierUlterieursJoursNameWithStepId];
                if (travauxCtrl.value === "travaux" && calendrierUlterieursMoisCtrl.value !== "0" && calendrierUlterieursJoursCtrl.value !== "0") {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}